import { memo } from "react";
import { Box } from "../../../common/components";
import { createStyles, palette, spacing } from "../../../styles/theme";
import { ComboItems, ItemPricing } from "../../../types";
import CartItemSizeSelectorContent from "./CartItemSizeSelectorContent";

const useStyles = (isBundle: boolean) =>
  createStyles({
    container: {
      backgroundColor: "white",
      borderRadius: "8px",
    },
    bundleHeader: {
      p: spacing.groupingMobile,
      borderRadius: "4px 4px 0 0",
      background: palette.grey.lightBackground,
      overflow: "hidden",
    },
  });

interface Props {
  item: ItemPricing;
  comboItems: ComboItems;
  onRemove: (id: string, productName: string) => void;
  showBundleHeader?: boolean;
}

const CartItemSizeSelector = ({ onRemove, item, comboItems }: Props) => {
  const isBundle = comboItems.items?.length > 1;
  const styles = useStyles(isBundle);

  return (
    <Box
      sx={{ ...styles.container }}
      data-test={`cartItem.${item.designName}`}
      className={isBundle ? "cartItemSizeSelector--bundle" : ""}
    >
      <CartItemSizeSelectorContent
        isBundle={isBundle}
        key={item.cartItemId}
        item={item}
        comboItems={comboItems}
        onRemove={onRemove}
      />
    </Box>
  );
};

export default memo(CartItemSizeSelector);
